import React from 'react';
import PropTypes from 'prop-types';
import { WithVdpShare } from 'site-modules/inventory/components/vdp-share/vdp-share';
import { Image } from 'site-modules/shared/components/image/image';
import { SOURCES } from 'client/utils/image-helpers';
import { get } from 'lodash-es';

import './share-button.scss';

export const ShareButton = ({ vehicle }) => {
  const { vin } = vehicle;
  const { make = '', model = '', year = 0 } = get(vehicle, 'vehicleInfo.styleInfo', {});

  return (
    <WithVdpShare year={year} make={make} model={model} vin={vin}>
      {({ onShare, isSupported, imageSrc, title }) => (
        <button
          className="vdp-share-button vdp-text-decoration-none-hover pos-r border-0 animated btn btn-outline-primary ms-0_5"
          onClick={onShare}
          aria-label="Share this listing"
          disabled={!isSupported}
          title={title}
        >
          <Image imageId={imageSrc} source={SOURCES.STATIC} width={20} height={20} ariaHidden lazy />
        </button>
      )}
    </WithVdpShare>
  );
};

ShareButton.propTypes = {
  vehicle: PropTypes.shape({
    vin: PropTypes.string.isRequired,
    vehicleInfo: PropTypes.shape({
      styleInfo: PropTypes.shape({
        make: PropTypes.string,
        model: PropTypes.string,
        year: PropTypes.number,
      }),
    }),
  }).isRequired,
};
